// extracted by mini-css-extract-plugin
export var colorBlack = "#000";
export var colorGray = "gray";
export var colorDarkGray = "#262626";
export var colorLightGray = "#e5e5e5";
export var colorWhite = "#fff";
export var colorElectricBlue = "#0000fe";
export var colorPastelBlue = "#bbe5fe";
export var colorCandyPink = "#f9709a";
export var colorPastelPink = "#ffcdd2";
export var colorDefaultLime = "#cef564";
export var colorPastelLime = "#eeffbe";
export var colorBlueLagoon = "#9cf0e1";
export var colorPastelLagoon = "#ceffec";
export var colorDefaultLavender = "#8738f6";
export var colorPastelLavender = "#eadcff";
export var colorBrightYellow = "#ffe500";
export var colorDefaultGreen = "#12b968";
export var breakpointMedium = "768px";
export var breakpointDesktop = "1024px";
export var breakpointLarge = "1440px";
export var colCount = "6";
export var colWidth = "16.6666666667%";
export var relative = "DataVizTimeline-module--relative--jpOoK";
export var imageContainer = "DataVizTimeline-module--imageContainer--s4URv";
export var image = "DataVizTimeline-module--image--2vn35";
export var textContainer = "DataVizTimeline-module--textContainer--1g1OY";
export var column = "DataVizTimeline-module--column--3SCuF";
export var leftAlignText = "DataVizTimeline-module--leftAlignText--1qxqQ";
export var isInView = "DataVizTimeline-module--isInView--BF4P1";
export var foreground = "DataVizTimeline-module--foreground--2TGbx";
export var outer = "DataVizTimeline-module--outer--2DTxd";
export var inner = "DataVizTimeline-module--inner--3mvZ5";
export var maskedContainerMobile = "DataVizTimeline-module--maskedContainerMobile--1PhLG";
export var background = "DataVizTimeline-module--background--2WFak";